import { withDefault } from '@weft/utils';
import type { Dayjs } from '@weft/utils';
import { getDefaultDates } from '../../pages/data-metering/utils/rangePickerUtils';
import { deserializeDateParam,
  serializeDateParam } from '../../utils/params-formatting';
import { useStateParams } from '../use-state-params';

export function useToDayParam(defaultDay?: Dayjs) {
  const [_defaultFromDay, defaultToDay] = getDefaultDates();

  return useStateParams(withDefault(defaultDay, defaultToDay), 'to', serializeDateParam, deserializeDateParam);
}